import { render, staticRenderFns } from "./albumItem.vue?vue&type=template&id=2708eb12&scoped=true"
import script from "./albumItem.vue?vue&type=script&lang=js"
export * from "./albumItem.vue?vue&type=script&lang=js"
import style0 from "./albumItem.vue?vue&type=style&index=0&id=2708eb12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2708eb12",
  null
  
)

export default component.exports